import axios from "axios";

class AuthService {
	login(user) {
		return axios.post(process.env.VUE_APP_SERVER_LINK + "/login", user).then((response) => {
			if (response.data.accessToken) {
				localStorage.setItem("user", JSON.stringify(response.data));
			}

			return response.data;
		});
	}

	forgotPassword(data) {
		return axios.post(process.env.VUE_APP_SERVER_LINK + "/password/forgot", data);
	}

	resetPassword(data) {
		return axios.post(process.env.VUE_APP_SERVER_LINK + "/password/reset", data).then((response) => {
			if (response.data.accessToken) {
				localStorage.setItem("user", JSON.stringify(response.data));
			}

			return response;
		});
	}

	changePassword(data) {
		return axios.post(process.env.VUE_APP_SERVER_LINK + "/password/change", data, { headers: this.authHeader() });
	}

	logout() {
		localStorage.removeItem("user");
	}

	authHeader(type = 'api') {
		const user = JSON.parse(localStorage.getItem("user"));

		if (user && user.accessToken) {
			if (type === "api") {
				return { 'x-access-token': user.accessToken };
			} 

			if (type === "socket") {
				return { token: "Bearer " + user.accessToken };
			} 
		} else {
			return {};
		}
	}
}

export default new AuthService();
